import { add, isAfter, isBefore } from '@calendly/datetime'
import { I18n } from '@calendly/i18n'
import { isEqual } from 'lodash-es'

import { formatTime, parseTime } from 'services/time_format'

const isSameOrAfter = (a, b) => isBefore(a, b) === false
const isSameOrBefore = (a, b) => isAfter(a, b) === false

const parseInterval = (interval) => {
  const from = parseTime(interval.from)
  let to = parseTime(interval.to)

  if (to && formatTime(to, '24h') === '00:00') {
    to = add(to, 1, 'day')
  }

  return { from, to }
}

const getError = (interval) => {
  const { from, to } = parseInterval(interval)

  if (!from) return 'invalid_time_from'
  if (!to) return 'invalid_time_to'
  if (!isBefore(from, to)) return 'invalid_duration'

  return undefined
}

const isOverlapping = (a, b) => {
  const x = parseInterval(a)
  const y = parseInterval(b)

  const xFromInsideY = isSameOrAfter(x.from, y.from) && isBefore(x.from, y.to)
  const xToInsideY = isAfter(x.to, y.from) && isSameOrBefore(x.to, y.to)
  const yInsideX = isSameOrBefore(x.from, y.from) && isSameOrAfter(x.to, y.to)

  return xFromInsideY || xToInsideY || yInsideX
}

export const validateIntervals = (intervals) => {
  const validatedIntervals = intervals.map((interval) => ({
    ...interval,
    error: getError(interval)
  }))

  validatedIntervals.forEach((a, index) => {
    if (a.error && a.error !== 'overlap') return

    const otherIntervals = validatedIntervals.slice(index + 1)

    otherIntervals.forEach((b) => {
      if (b.error && b.error !== 'overlap') return

      if (isOverlapping(a, b)) {
        a.error = 'overlap'
        b.error = 'overlap'
      }
    })
  })

  return validatedIntervals
}

const sortByStartTime = (a, b) => {
  const aFrom = parseTime(a.from)
  const bFrom = parseTime(b.from)
  if (aFrom == null || bFrom == null) return 0
  return isBefore(aFrom, bFrom) ? -1 : 1
}

export const validateAndSortIntervals = (intervals) => {
  const validated = validateIntervals(intervals)

  if (validated.every(({ error }) => !error)) {
    validated.sort(sortByStartTime)
  }

  return validated
}

export const checkIntervalsSorted = (intervals, sortedIntervals) => {
  const intervalsStartTimes = intervals.map(({ from }) => from)
  const sortedIntervalsStartTimes = sortedIntervals.map(({ from }) => from)

  return !isEqual(intervalsStartTimes, sortedIntervalsStartTimes)
}

export const generateSortedIntervalsAnnouncement = (intervals, timeNotation) => {
  const sortedAnnouncement = intervals.map(({ from, to }) => {
    const intervalStart = parseTime(from)
    const intervalEnd = parseTime(to)
    const formattedIntervalStart = formatTime(intervalStart, timeNotation)
    const formattedIntervalEnd = formatTime(intervalEnd, timeNotation)

    return `${I18n.t('publisher.event_types.availability.from')}
    ${formattedIntervalStart} ${I18n.t('publisher.event_types.availability.to')} ${formattedIntervalEnd}`
  })

  return sortedAnnouncement.join(', ')
}
